// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronDown = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M16,2.5l-0.1,0.1L8,9L0,2.5V7l6.6,5.3L8,13.5l1.4-1.2L16,7.1V2.5L16,2.5z" />
    </svg>
  );
};
